/*!
 * ignore
 */

'use strict';

module.exports = function() {};



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/drivers/browser/ReadPreference.js
// module id = 359
// module chunks = 0